import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SocialMetaTagsProps {
  title: string;
  description: string;
  image: string;
  url: string;
  type?: 'website' | 'article';
}

const SocialMetaTags: React.FC<SocialMetaTagsProps> = ({
  title,
  description,
  image,
  url,
  type = 'website'
}) => {
  const siteName = 'Deepnets.ai';
  const twitterHandle = '@deepnets_ai'; // You might want to update this

  return (
    <Helmet>
      {/* Basic meta tags */}
      <title>{title}</title>
      <meta name="description" content={description} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={siteName} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
      {twitterHandle && <meta property="twitter:site" content={twitterHandle} />}

      {/* Additional meta tags */}
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={url} />
    </Helmet>
  );
};

export default SocialMetaTags;
